import { render, staticRenderFns } from "./RequestReasonList.vue?vue&type=template&id=fcb203a8&scoped=true"
import script from "./RequestReasonList.vue?vue&type=script&lang=js"
export * from "./RequestReasonList.vue?vue&type=script&lang=js"
import style0 from "./RequestReasonList.vue?vue&type=style&index=0&id=fcb203a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb203a8",
  null
  
)

export default component.exports